import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { Router } from '@angular/router';
import { ContentUnavailableMessageComponent } from './content-unavailable-message.component';

const HEADING_ID = 'content-unavailable-dialog-title';

/** Dialog variant, shown over the current screen when an in-app click (e.g. a notification) can't be followed. */
@Component({
  selector: 'mtm-content-unavailable-dialog',
  standalone: true,
  imports: [ContentUnavailableMessageComponent],
  templateUrl: './content-unavailable-dialog.component.html',
  styleUrl: './content-unavailable-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentUnavailableDialogComponent {
  private readonly dialogRef = inject(DialogRef);
  private readonly router = inject(Router);

  protected readonly headingId = HEADING_ID;

  protected goHome(): void {
    this.close();
    this.router.navigateByUrl('/');
  }

  protected close(): void {
    this.dialogRef.close();
  }
}

export const openContentUnavailableDialog = (dialog: Dialog): DialogRef<unknown, ContentUnavailableDialogComponent> =>
  dialog.open(ContentUnavailableDialogComponent, {
    width: '380px',
    maxWidth: '94vw',
    backdropClass: 'mtm-content-unavailable-backdrop',
    ariaLabelledBy: HEADING_ID,
    ariaModal: true,
  });
